import React, { createRef } from 'react';
import { IonSearchbar, IonButton, IonChip, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonActionSheet, IonInput, IonButtons, IonBackButton, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import '../styles/Studyset.scss';
import Storage from '../Storage';
import Utilities from '../Utilities';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { car, close, closeCircle } from 'ionicons/icons'
import Flashcard from './Flashcard';
import '../styles/LinkEditorModal.scss';
import Drawer from '@material-ui/core/Drawer';
import SQLStorage from '../SQLStorage';
import { isPlatform } from '@ionic/react';
import { Keyboard } from '@capacitor/keyboard';

class LinkEditorModal extends React.Component {

    constructor(props) {

        super(props);
        this.modalRef = createRef();
        this.state = {
            matches: [],
            currentLinks: [],
            keywords: "",
            activated: true
        }

        if (isPlatform("ios")) {

            // Keyboard.setResizeMode({mode:"body"}) // Keyboard.setResizeMode("body")

            Keyboard.addListener('keyboardWillShow', (info) => {
                this.setState({ keyboardShowing: true })
                window.keyboardHeight = info.keyboardHeight;
                if (this.modalRef.current) {
                    // this.modalRef.current.style.setProperty('margin-top', (info.keyboardHeight + (window.notchSizeTop || 0) ) + "px", "important");
                    this.modalRef.current.parentNode.style.setProperty('bottom', info.keyboardHeight + "px");
                }
                let drawer = window.document.querySelectorAll(".link-editor-modal");
                if (drawer && drawer[0])
                    drawer[0].style.maxHeight = 'calc(100vh - ' + (window.keyboardHeight + 80) + 'px)';
            });

            Keyboard.addListener('keyboardWillHide', () => {
                this.setState({ keyboardShowing: false })
                if (this.modalRef.current) {
                    this.modalRef.current.parentNode.style.setProperty('bottom', 0 + "px");
                    // this.modalRef.current.style.setProperty('margin-top', "12px", "important");
                }
            });

        }

        if (props.currentLinks) {
            this.reloadLinkData(props.currentLinks)
        }

    }

    async reloadLinkData(currentLinks) {
        let links = currentLinks.length !== 0 ? (await SQLStorage.getCardsByIds(currentLinks, true)) : [];
        console.log(links)
        this.setState({
            currentLinks: links,
            keywords: "",
            matches: []
        })
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.cardId !== this.props.cardId) {
            Utilities.onDrawerShow();
            this.reloadLinkData(nextProps.currentLinks)
        } else if (!Utilities.arrayEquals(nextProps.currentLinks, this.state.currentLinks.map(item => item.id))) {
            this.reloadLinkData(this.state.currentLinks.map(item => item.id))
        }
    }

    async componentDidMount() {
        if (!window.activated) {
            let linkCount = await SQLStorage.getCardsCountWithLinks();
            if (linkCount > 20) {
                this.setState({ activated: false })
            }
        }
    }

    save() {
        this.props.onClose(this.state.currentLinks.map(item => item.id));
    }

    async search() {
    
        if (this.state.keywords.length > 0) {
            let matches = await SQLStorage.searchCards(this.state.keywords, [], 80);
            this.setState({ matches: matches.length === 0 ? [] : matches})
        } else {
            this.setState({ matches: [] })
        }

    }

    render() {
        return (
            <SwipeableDrawer
                anchor="bottom"
                open={(this.props.cardId !== null)}
                key="link-editor"
                onClose={ () => {
                    this.save();
                } }
                onOpen={ () => {

                } }
            >
                <div
                    className="link-editor-modal"
                    data-keyboard-showing={this.state.keyboardShowing} 
                    ref={this.modalRef} 
                >
                    {/* <IonHeader>
                        <IonToolbar>
                            <IonTitle>{window.ln.selectCardsToLink}</IonTitle>
                            <IonButtons slot="end">
                                <IonIcon style={{ width: 24, height: 24, marginRight: 8, marginTop: -3, color: "#333" }} icon={close} onClick={() => {  }} />
                            </IonButtons>
                        </IonToolbar>
                    </IonHeader> */}
                    <div className="drag-indicator"></div>
                    <h2>{window.ln.selectCardsToLink}</h2>
                    <div className="drag-close-indicator" onClick={() => {
                        Utilities.onDrawerHide();
                        this.props.onClose()
                    }}>
                        <IonIcon icon={closeCircle} />
                    </div>
                    <section className="edit">
                        <div className="search-cards">
                            <div className="search">
                                <IonSearchbar
                                    debounce={700}
                                    id="search-bar"
                                    showCancelButton="focus"
                                    value={this.state.keywords}
                                    onIonChange={(e) => {
                                        this.setState({
                                            keywords: e.target.value.trim().toLowerCase()
                                        }, function() {
                                            this.search()
                                        })
                                    }}
                                    placeholder={window.ln.searchInAll}
                                    onIonClear={() => {
                                        this.setState({
                                            keywords: ""
                                        }, function() {
                                            this.search()
                                        })
                                    }}
                                />
                                { (this.state.matches.length === 0 && this.state.activated && this.state.keywords.length !== 0) &&
                                    <div className="not-enough-keywords">
                                        <h2>{window.ln.noMatch}</h2>
                                    </div>
                                }
                            </div>
                            <div className="list">
                                { this.state.currentLinks.map((item, i) => {
                                    return (
                                        <Flashcard
                                            key={item.id}
                                            onClick={ async () => {
                                                let newCurrentLinks = JSON.parse(JSON.stringify(this.state.currentLinks));
                                                const existing = newCurrentLinks.find(card => card.id === item.id);
                                                Utilities.trackEvent("Flashcard", "Flashcard Link Toggle", this.props.cardId, existing ? 0 : 1);
                                                if (existing) {
                                                    newCurrentLinks = newCurrentLinks.filter(card => card.id !== item.id);
                                                } else {
                                                    newCurrentLinks.push(item);
                                                }
                                                this.setState({ currentLinks: newCurrentLinks })
                                            }}
                                            altChip={this.state.currentLinks.map(sitem => sitem.id).indexOf(item.id) !== -1 ? (window.ln.alreadyLinked) : ""}
                                            tags={this.props.tags}
                                            flashcard={item} 
                                            i={i} 
                                            definition={""} 
                                            term={""} 
                                            definitionPronouncation={""} 
                                            termPronouncation={""} 
                                            view="minimal"
                                        />
                                    )
                                }) }
                                { this.state.matches.map((item, i) => {
                                    if (this.state.currentLinks.map(sitem => sitem.id).indexOf(item.id) !== -1)
                                        return null;

                                    return (
                                        <Flashcard
                                            key={item.id}
                                            onClick={ async () => {
                                                if (!this.state.activated) {
                                                    window.showSubscriptionModal("links");
                                                    return;
                                                }
                                                let newCurrentLinks = JSON.parse(JSON.stringify(this.state.currentLinks));

                                                const existing = newCurrentLinks.find(card => card.id === item.id);
                                                Utilities.trackEvent("Flashcard", "Flashcard Link Toggle", this.props.cardId, existing ? 0 : 1);
                                                if (existing) {
                                                    newCurrentLinks = newCurrentLinks.filter(card => card.id !== item.id);
                                                } else {
                                                    newCurrentLinks.push(item);
                                                }
                                                console.log("NEW CURRENT LINKS: ", newCurrentLinks);
                                                this.setState({ currentLinks: newCurrentLinks })
                                            }}
                                            tags={this.props.tags}
                                            flashcard={item} 
                                            i={i} 
                                            definition={""} 
                                            term={""} 
                                            definitionPronouncation={""} 
                                            termPronouncation={""} 
                                            view="minimal"
                                        />
                                    )
                                }) }
                            </div>
                        </div>
                        <div className="opts">
                            <div className="right">
                                <button 
                                    className="save" 
                                    onClick={() => { 
                                        Utilities.trackEvent("Flashcard", "Flashcard Link Save Click", this.props.cardId);
                                        this.save();
                                    }}
                                    data-has-changed="true"
                                >{window.ln.save}</button>
                            </div>
                        </div>
                    </section>
               </div>
           </SwipeableDrawer>
        );
    }

};


export default withIonLifeCycle(LinkEditorModal);
